@if (visible()) {
  <div class="modal-backdrop" (click)="onCancel()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">{{ title() }}</h2>
        <button type="button" class="modal-close" (click)="onCancel()" aria-label="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="modal-content">
        <p class="modal-message">{{ message() }}</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="modal-button cancel-button"
          (click)="onCancel()">
          {{ cancelText() }}
        </button>
        <button
          type="button"
          class="modal-button confirm-button"
          (click)="onConfirm()">
          {{ confirmText() }}
        </button>
      </div>
    </div>
  </div>
}

